/** @format */

import React from 'react'
import { useSelector } from 'react-redux'
import classNames from 'classnames'

import { overlaySelectors } from 'services/globalSelectors'
import { Body, Toolbar, Sidebar } from 'screens'

import styles from './authorized.module.css'

export const Authorized = () => {
  const isOpenSidebar = useSelector(overlaySelectors.isOpenSidebar)
  const wrapperStyles = classNames({
    [styles.wrapper]: true,
    [styles.wrapperWithOutSidebar]: !isOpenSidebar,
  })

  return (
    <div className={wrapperStyles}>
      {isOpenSidebar && <Sidebar />}
      <div className={styles.body}>
        <Toolbar />
        <Body />
      </div>
    </div>
  )
}
